/**
 * Colors for the report's inline SVG charts.
 *
 * SVG `stroke` / `fill` need a literal color string, so they cannot use
 * NativeWind classes. These resolve through the same CSS custom properties the
 * Tailwind theme is built on (`--color-brand-500` holds a bare `R G B` triple),
 * which keeps the charts on-palette in light and dark mode and across tenants.
 * Never inline a hex value at a chart's use site — add a token here instead.
 */

const themed = (variable: string, alpha?: number): string =>
  alpha === undefined
    ? `rgb(var(${variable}))`
    : `rgb(var(${variable}) / ${alpha})`;

export const CHART_COLORS = {
  /** Primary series line. */
  primary: themed("--color-brand-500"),
  /** Area beneath the primary series. */
  primaryFill: themed("--color-brand-500", 0.12),
  /** Secondary, dashed series (e.g. engagement rate against reach). */
  secondary: themed("--color-success-500"),
  /** Unfilled portion of a track, e.g. the donut's remainder. */
  track: themed("--color-outline-100"),
  /** Annotation lines, e.g. the campaign-start marker. */
  marker: themed("--color-typography-400"),
} as const;

/** Donut segments for the gender split, keyed by the backend's display label. */
export const GENDER_COLORS: Record<string, string> = {
  Mujeres: themed("--color-brand-500"),
  Hombres: themed("--color-info-500"),
};

export const DEFAULT_GENDER_COLOR = themed("--color-outline-300");
